import type { Model, Slicer } from '../../types';

export interface CountryState {
  country: string;
  state: string;
}
const reducers = {
  set: (state: CountryState, payload: CountryState) => payload
};
const selectors = (slice: Slicer<CountryState>) => ({
  get() {
    return slice;
  },
  getCountry() {
    return slice((state) => state.country);
  },
  getState() {
    return slice((state) => state.state);
  }
});

const country: Model<CountryState, typeof reducers, void, void, typeof selectors> = {
  state: { country: '', state: '' },
  reducers,
  selectors
};

export default country;
